import { c as _c } from "react/compiler-runtime";
import SvgIcon from '@mui/material/SvgIcon';

// ----------------------------------------------------------------------

/**
 * Icons
 * @see https://icon-sets.iconify.design/eva/arrow-ios-downward-fill/
 */
const ArrowDownIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="m12 16-.6-.2-6-5a1 1 0 1 1 1.2-1.6l5.4 4.5 5.4-4.3a1 1 0 0 1 1.4.1 1 1 0 0 1-.2 1.5l-6 4.8z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const MuiSelect = {
  /** DEFAULT PROPS */
  defaultProps: {
    IconComponent: ArrowDownIcon
  },
  /** STYLE */
  styleOverrides: {
    icon: {
      right: 10,
      width: 18,
      height: 18,
      top: 'calc(50% - 9px)'
    }
  }
};
const MuiNativeSelect = {
  /** DEFAULT PROPS */
  defaultProps: {
    IconComponent: ArrowDownIcon
  },
  /** STYLE */
  styleOverrides: {
    icon: {
      right: 10,
      width: 18,
      height: 18,
      top: 'calc(50% - 9px)'
    }
  }
};
export const select = {
  MuiSelect,
  MuiNativeSelect
};